import { Box } from "grid-styled";
import * as React from "react";
import { darken } from "polished";
import { Link } from "react-router-dom";
import { media } from "../../breakpoints";
import styled from "../../styled-components";

const LinkStyle = `border-bottom: 1px solid #d9d9d9;
  padding: 5px 0 5px 5px;
  color: #000;
  display: block;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  transition: background 0.25s ease-in-out;

  &:hover {
    background: ${darken(0.1, "#fff")};
    cursor: pointer;
  }

  @media ${media.TABLET`
   font-size: 16px;
  `};`;

const NavigationItem = styled(Link)`
  ${LinkStyle};
`;

const NavigationItemA = styled.a`
  ${LinkStyle};
`;

const Bold = styled.span`
  font-weight: 800;
`;

const Wrapper = styled(Box)<{ isOpen: boolean }>`
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  visibility: ${({ isOpen }) => (isOpen ? "visible" : "hidden")};
  bottom: auto;
  width: 130px;
  text-align: left;
  box-shadow: 0 -1px 7px 0 rgba(0, 0, 0, 0.1);
  display: block;
  left: auto;
  top: 50px;
`;

const StyledNav = styled.nav<{ isOpen: boolean }>`
  background: ${({ theme }) => theme.colors.white};
  transition: transform 0.25s ease-in-out;
  bottom: auto;
  position: relative;
  transform: none;
  width: 100%;
  right: 0;
`;

interface INavigationProps {
  isOpen: boolean;
  onClose: () => void;
}

const NavBox: React.SFC<INavigationProps> = ({ isOpen, onClose }) => {
  return (
    <Wrapper isOpen={isOpen} mr={[0, 3, 3, 5]} tabIndex={1}>
      <StyledNav isOpen={isOpen}>
        <NavigationItem to="/faq" aria-label="FAQ page">
          FAQ
        </NavigationItem>
        <NavigationItemA
          href={
            process.env.REACT_APP_WWW === "rocks"
              ? "https://www.say.rocks/qa/"
              : "https://www.saytechnologies.com/qa/"
          }
          target="_blank"
          aria-label="Earnings Calls page"
        >
          Earnings Call
        </NavigationItemA>

        <NavigationItem
          to="/"
          onClick={e => {
            e.preventDefault();
            onClose();
          }}
          onBlur={onClose}
          aria-label="Close Menu"
        >
          <Bold>Close</Bold>
        </NavigationItem>
      </StyledNav>
    </Wrapper>
  );
};

export default NavBox;



// WEBPACK FOOTER //
// ./src/components/Nav/NavBox.tsx